// The portal's tracker: a thin binding of the shared browser tracker.
//
// Everything substantive lives in @terramantle/web-telemetry. This file used to be 395 lines, of
// which only ~70 differed from the marketing site's copy - and every real difference was config, not
// logic. See that package's README for why the two were collapsed.
//
// The portal's three config choices, and why:
//  - service.name 'terramantle-app', so the two front-ends are separable by resource attribute (§4);
//  - /callback is EXCLUDED: it carries the OIDC ?code=, and nothing may be emitted from it. The one
//    exception is trackError, which may report an auth failure carrying only the closed stage enum
//    and the opaque ids - see @terramantle/web-telemetry's trackError doc;
//  - installNoReferrer, because the OTLP exporter gives no way to set a referrerPolicy on its
//    requests, so without it the full authenticated URL would ride along as a Referer.
//
// Propagation is scoped to the registry origin ONLY. That is what makes the Worker's server span a
// real CHILD of the browser's fetch span, and therefore what makes §21's structural query
// `{browser error} >> {worker error}` resolve - but a wider scope would leak internal ids to every
// third party the page talks to.
import { createTracker } from '@terramantle/web-telemetry'

const tracker = createTracker({
  // Passed in, not read inside the shared package: Vite inlines these at build time in THIS module's
  // graph, and a workspace dependency is not guaranteed to see the same `import.meta.env`.
  env: import.meta.env as unknown as Record<string, string | undefined>,
  serviceName: 'terramantle-app',
  excludePaths: ['/callback'],
  installNoReferrer: true,
  propagateTo: [/^https:\/\/registry\.terramantle\.dev/],
})

export const {
  sessionId,
  deviceId,
  setUser,
  captureCampaign,
  resetTelemetryIdentity,
  trackPageView,
  trackEvent,
  trackHealthcheck,
  trackError,
  trackTiming,
  flush,
  startJourney,
  endJourney,
  currentJourney,
  currentJourneyBaggage,
  traceHeaders,
  __resetPathState,
  __resetTelemetryForTest,
} = tracker
